export const MOBILE_LAYOUT = "899px";
export const PC_LAYOUT = "1440px";
